import { AxiosRequestConfig } from 'axios'

const leaveEvent = (type: string, id: string): AxiosRequestConfig => ({
  url: `/${type}/participation/leave`,
  method: 'POST',
  params: {
    id
  }
})

export { leaveEvent }
